const RepInventarioTK= () => {
  return (
    <div className="text-3xl font-bold text-green-600">
      Estas en Reporte Inventario Transkyrios
    </div>
  );
}

export default RepInventarioTK;